// Celebrity Video Controls Functionality
document.addEventListener('DOMContentLoaded', function() {
    const videoCards = document.querySelectorAll('.video-card');
    
    videoCards.forEach(card => {
        const video = card.querySelector('.celebrity-video');
        if (!video) return;
        
        const playBtn = card.querySelector('.video-play-btn');
        const muteBtn = card.querySelector('.video-mute-btn');
        const forwardBtn = card.querySelector('.video-forward-btn');
        const backwardBtn = card.querySelector('.video-backward-btn');
        const progressBar = card.querySelector('.video-progress-bar');
        const progressFilled = card.querySelector('.video-progress-filled');
        const currentTimeDisplay = card.querySelector('.current-time');
        const durationTimeDisplay = card.querySelector('.duration-time');
        
        // Format time helper
        function formatTime(seconds) {
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${mins}:${secs.toString().padStart(2, '0')}`;
        }
        
        // Update progress bar and time
        function updateProgress() {
            const percent = (video.currentTime / video.duration) * 100;
            progressFilled.style.width = `${percent}%`;
            currentTimeDisplay.textContent = formatTime(video.currentTime);
        }
        
        // Set duration when loaded
        video.addEventListener('loadedmetadata', function() {
            durationTimeDisplay.textContent = formatTime(video.duration);
        });
        
        // Update progress as video plays
        video.addEventListener('timeupdate', updateProgress);
        
        // Play/Pause button
        playBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            const playIcon = this.querySelector('.play-icon');
            const pauseIcon = this.querySelector('.pause-icon');
            
            if (video.paused) {
                video.play();
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            } else {
                video.pause();
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
            }
        });
        
        // Mute/Unmute button
        muteBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            const muteIcon = this.querySelector('.mute-icon');
            const unmuteIcon = this.querySelector('.unmute-icon');
            
            if (video.muted) {
                video.muted = false;
                muteIcon.style.display = 'none';
                unmuteIcon.style.display = 'block';
            } else {
                video.muted = true;
                muteIcon.style.display = 'block';
                unmuteIcon.style.display = 'none';
            }
        });
        
        // Forward 10 seconds
        forwardBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            video.currentTime = Math.min(video.currentTime + 10, video.duration);
        });
        
        // Backward 10 seconds
        backwardBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            video.currentTime = Math.max(video.currentTime - 10, 0);
        });
        
        // Progress bar seeking
        progressBar.addEventListener('click', function(e) {
            e.stopPropagation();
            const rect = this.getBoundingClientRect();
            const percent = (e.clientX - rect.left) / rect.width;
            video.currentTime = percent * video.duration;
        });
        
        // Set initial play/pause icon state (videos autoplay)
        video.addEventListener('play', function() {
            const playIcon = playBtn.querySelector('.play-icon');
            const pauseIcon = playBtn.querySelector('.pause-icon');
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'block';
        });
        
        video.addEventListener('pause', function() {
            const playIcon = playBtn.querySelector('.play-icon');
            const pauseIcon = playBtn.querySelector('.pause-icon');
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        });
    });
    
// FAQ/Terms Section Toggle Functionality
    const termsHeaders = document.querySelectorAll('.terms-header');
    
    termsHeaders.forEach(header => {
        header.addEventListener('click', function() {
            const termsItem = this.parentElement;
            const content = termsItem.querySelector('.terms-content');
            const isCurrentlyActive = termsItem.classList.contains('active');
            
            // Close all other open items first
            termsHeaders.forEach(otherHeader => {
                const otherTermsItem = otherHeader.parentElement;
                const otherContent = otherTermsItem.querySelector('.terms-content');
                
                if (otherContent && otherTermsItem !== termsItem) {
                    otherTermsItem.classList.remove('active');
                    otherContent.classList.remove('active');
                    otherContent.style.maxHeight = '0px';
                    otherContent.style.opacity = '0';
                }
            });
            
            // Toggle the clicked item
            if (!isCurrentlyActive) {
                termsItem.classList.add('active');
                content.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
                content.style.opacity = '1';
            } else {
                termsItem.classList.remove('active');
                content.classList.remove('active');
                content.style.maxHeight = '0px';
                content.style.opacity = '0';
            }
        });
    });
    
    // Set proper max-height for the initially active item
    const activeItem = document.querySelector('.terms-item.active');
    if (activeItem) {
        const activeContent = activeItem.querySelector('.terms-content');
        if (activeContent) {
            activeContent.style.maxHeight = activeContent.scrollHeight + 'px';
            activeContent.style.opacity = '1';
        }
    }
});



// Sticky Side Button & Popup Modal Functionality

document.addEventListener('DOMContentLoaded', function() {
    const stickyBtn = document.getElementById('stickyBtn');
    const popupOverlay = document.getElementById('popupOverlay');
    const popupClose = document.getElementById('popupClose');
    
    // Open popup when sticky button is clicked
    if (stickyBtn) {
        stickyBtn.addEventListener('click', function() {
            openPopup();
        });
    }
    
    // Close popup when close button is clicked
    if (popupClose) {
        popupClose.addEventListener('click', function() {
            closePopup();
        });
    }
    
    // Close popup when clicking on overlay (outside popup content)
    if (popupOverlay) {
        popupOverlay.addEventListener('click', function(e) {
            if (e.target === popupOverlay) {
                closePopup();
            }
        });
    }
    
    // Close popup when pressing Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popupOverlay && popupOverlay.classList.contains('active')) {
            closePopup();
        }
    });
    
    // Function to open popup
    function openPopup() {
        if (popupOverlay) {
            popupOverlay.classList.add('active');
            document.body.style.overflow = 'hidden'; // Prevent scrolling when popup is open
        }
    }
    
    // Function to close popup
    function closePopup() {
        if (popupOverlay) {
            popupOverlay.classList.remove('active');
            document.body.style.overflow = ''; // Re-enable scrolling
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const luckyBtn = document.getElementById('luckyWinnerBtn');
    const popup = document.getElementById('lucky-popupOverlay');
    const closeBtn = document.getElementById('lucky-popupClose');

    // Exit early if required elements are missing
    if (!luckyBtn || !popup || !closeBtn) return;

    // Open popup when button is clicked
    luckyBtn.addEventListener('click', openPopup);

    // Close popup when close button is clicked
    closeBtn.addEventListener('click', closePopup);

    // Close popup when clicking on overlay (outside popup content)
    popup.addEventListener('click', function(e) {
        if (e.target === popup) closePopup();
    });

    // Close popup when pressing Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('lucky-active')) {
            closePopup();
        }
    });

    function openPopup() {
        popup.classList.add('lucky-active');
        document.body.classList.add('lucky-popup-open');
    }

    function closePopup() {
        popup.classList.remove('lucky-active');
        document.body.classList.remove('lucky-popup-open');
    }
});